import React, { useRef, useEffect, useState } from "react"
import { NavLink as Link } from "react-router-dom"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Layout, Dropdown, Menu, Badge } from "antd"
import {
  DownOutlined,
  UserOutlined,
  BellOutlined,
  LogoutOutlined,
} from "@ant-design/icons"

import ROLES from "../../../_shared/constants/roles.js"
import { useStateValue } from "../../../_shared/context/AppStateStore"
import useStateActions from "../../../_shared/context/AppStateStore/actions"

// ----------------------------------------------------------------------------

const { Header } = Layout

//------------------------------------------------------------------------------

function AppHeader(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  const appState = useStateValue()
  const [{ user }, dispatch] = appState
  const stateActions = useStateActions(appState)

  const containerRef = useRef(null)

  // -------------------------------------
  // Effects
  // -------------------------------------

  useEffect(() => {
    stateActions.getUserUnreadedMessages()

    //eslint-disable-next-line
  }, [])

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function handleSignOut() {
    dispatch({
      type: "SIGN_OUT",
    })
  }

  function getDropdownContent() {
    return (
      <Menu>
        <Menu.Item key="signOut">
          <LogoutOutlined />
          <a onClick={handleSignOut}>Logout</a>
        </Menu.Item>
      </Menu>
    )
  }

  function getUserName() {
    switch (user.role) {
      case ROLES.USER: {
        return user?.companyName
      }

      default: {
        return user?.name
      }
    }
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  return (
    <Header className={props.className}>
      <section className="left-section" />
      <section className="right-section" ref={containerRef}>
        <Link to="/tickets">
          <div className="round-icn right-margined clickable">
            <Badge count={user?.unreadedMessages}>
              <BellOutlined />
            </Badge>
          </div>
        </Link>

        <Dropdown
          overlay={getDropdownContent}
          trigger={["click"]}
          getPopupContainer={() => {
            return containerRef && containerRef.current
          }}
        >
          <div className="drowpdown-container">
            <div className="round-icn">
              <UserOutlined />
            </div>
            <span>{getUserName()}</span>
            <DownOutlined />
          </div>
        </Dropdown>
      </section>
    </Header>
  )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

AppHeader.propTypes = {
  className: PropTypes.string.isRequired,
}

AppHeader.defaultProps = {}

// ----------------------------------------------------------------------------

const StyledAppHeader = styled(AppHeader)`
  & {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    background-color: ${(props) =>
      props.theme.colors.primaryBackgroundColor} !important;

    .clickable {
      cursor: pointer;
    }

    .left-section {
      flex: 1;
    }

    .right-section {
      display: flex;
      flex-direction: row;
      align-items: center;
      color: ${(props) => props.theme.colors.textDark};

      .round-icn {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        width: 40px;
        height: 40px;

        background-color: ${(props) =>
          props.theme.colors.secondaryBackgroundColor};
        border-radius: 50%;

        box-shadow: ${(props) => props.theme.shadows.iconBoxShadow};

        .anticon {
          font-size: 18px;
          color: ${(props) => props.theme.colors.iconColor};
        }
      }

      .right-margined {
        margin-right: 15px;
      }

      .drowpdown-container {
        display: flex;
        flex-direction: row;
        align-items: center;

        cursor: pointer;

        > span {
          margin: 0 5px 0 15px;
          user-select: none;
        }
      }

      /* Dropdown style */

      .ant-dropdown {
        ul {
          background-color: ${(props) =>
            props.theme.colors.lighterBackgroundColor};

          li {
            a {
              color: ${(props) => props.theme.colors.textDark};

              :hover {
                text-decoration: none;
                color: ${(props) => props.theme.colors.textLight};
              }
            }

            :hover {
              background-color: ${(props) =>
                props.theme.colors.lighterBackgroundColor};
            }
          }

          .ant-dropdown-menu-item {
            display: flex;
            flex-direction: row;
            align-items: center;
          }

          .ant-dropdown-menu-item-divider {
            margin: auto;
            width: 90%;
            background-color: ${(props) => props.theme.colors.dividerColor};

            :hover {
              background-color: ${(props) => props.theme.colors.dividerColor};
            }
          }
        }
      }
    }
  }
`
// ----------------------------------------------------------------------------

export default StyledAppHeader
